// @generated by protoc-gen-connect-web v0.6.0 with parameter "target=ts,ts_nocheck=false"
// @generated from file api/scribe/svc_analytics_model.proto (package com.diagnocat.scribe, syntax proto3)
/* eslint-disable */

import { CloneAnalyticsModelReq, CloneAnalyticsModelResp, CreateAnalyticsModelReq, CreateAnalyticsModelResp, DeleteAnalyticsModelReq, DeleteAnalyticsModelResp, GetAnalyticsModelByCodeReq, GetAnalyticsModelByCodeResp, GetAnalyticsModelBySeriesIDReq, GetAnalyticsModelBySeriesIDResp, GetAnalyticsModelReq, GetAnalyticsModelResp, ListAnalyticsModelsReq, ListAnalyticsModelsResp, RestoreAnalyticsModelReq, RestoreAnalyticsModelResp, UpdateAnalyticsModelReq, UpdateAnalyticsModelResp } from "./svc_analytics_model_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service com.diagnocat.scribe.AnalyticsModelService
 */
export const AnalyticsModelService = {
  typeName: "com.diagnocat.scribe.AnalyticsModelService",
  methods: {
    /**
     * @generated from rpc com.diagnocat.scribe.AnalyticsModelService.Get
     */
    get: {
      name: "Get",
      I: GetAnalyticsModelReq,
      O: GetAnalyticsModelResp,
      kind: MethodKind.Unary,
    },
    /**
     * Resolves the current version of a model series.
     *
     * @generated from rpc com.diagnocat.scribe.AnalyticsModelService.GetBySeriesID
     */
    getBySeriesID: {
      name: "GetBySeriesID",
      I: GetAnalyticsModelBySeriesIDReq,
      O: GetAnalyticsModelBySeriesIDResp,
      kind: MethodKind.Unary,
    },
    /**
     * OrganizationID, Language and Code together identify a model uniquely.
     *
     * @generated from rpc com.diagnocat.scribe.AnalyticsModelService.GetByCode
     */
    getByCode: {
      name: "GetByCode",
      I: GetAnalyticsModelByCodeReq,
      O: GetAnalyticsModelByCodeResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.scribe.AnalyticsModelService.List
     */
    list: {
      name: "List",
      I: ListAnalyticsModelsReq,
      O: ListAnalyticsModelsResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.scribe.AnalyticsModelService.Create
     */
    create: {
      name: "Create",
      I: CreateAnalyticsModelReq,
      O: CreateAnalyticsModelResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.scribe.AnalyticsModelService.Update
     */
    update: {
      name: "Update",
      I: UpdateAnalyticsModelReq,
      O: UpdateAnalyticsModelResp,
      kind: MethodKind.Unary,
    },
    /**
     * Soft-delete, reversed by Restore. System-owned models are protected.
     *
     * @generated from rpc com.diagnocat.scribe.AnalyticsModelService.Delete
     */
    delete: {
      name: "Delete",
      I: DeleteAnalyticsModelReq,
      O: DeleteAnalyticsModelResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.scribe.AnalyticsModelService.Restore
     */
    restore: {
      name: "Restore",
      I: RestoreAnalyticsModelReq,
      O: RestoreAnalyticsModelResp,
      kind: MethodKind.Unary,
    },
    /**
     * Copies community or official assets into the caller's organization.
     *
     * @generated from rpc com.diagnocat.scribe.AnalyticsModelService.Clone
     */
    clone: {
      name: "Clone",
      I: CloneAnalyticsModelReq,
      O: CloneAnalyticsModelResp,
      kind: MethodKind.Unary,
    },
  }
} as const;

